import { action, observable } from "mobx";
import ReactDOM from "react-dom";
import { renderRenderable } from "../utils/components.utils";
export var makePortalController = function () {
    var c = observable({
        ref: null,
        registerRef: action(function (ref) {
            c.ref = ref;
        }),
        // registry: [] as string[],
        // get hasContent(): boolean {
        //   return c.registry.length > 0;
        // },
        render: function (renderable) {
            var _a, _b;
            if (!((_a = c.ref) === null || _a === void 0 ? void 0 : _a.current)) {
                // console.warn('No target DOM element found for portal controller. Trying to render:', renderable);
                return null;
            }
            return ReactDOM.createPortal(renderRenderable(renderable), (_b = c.ref) === null || _b === void 0 ? void 0 : _b.current);
        },
    });
    return c;
};
